import Guid from "_shared/guids/guid";
import { FieldRedlineArray } from "work/proposals/redlining/field-redlines/field-redline";
import WorkDocument from "work/work-agreements/contracts/work-document";

export default function getReplacementDocumentTemplateIds(
  documentsRedline: FieldRedlineArray<WorkDocument>,
  documentId: Guid | null | undefined
): Guid[] | undefined {
  if (!documentId) return undefined;

  const documentRedline = documentsRedline.redlines.find(
    (redline) =>
      redline.currentEntry?.id.isEqualTo(documentId) ||
      redline.revisedEntry?.id.isEqualTo(documentId) ||
      redline.originalEntry?.id.isEqualTo(documentId)
  );

  const documentToReplace =
    [documentRedline?.currentEntry, documentRedline?.revisedEntry, documentRedline?.originalEntry]
      .find((document) => document?.id.isEqualTo(documentId)) ??
    documentRedline?.currentEntry ??
    documentRedline?.revisedEntry ??
    documentRedline?.originalEntry;

  return documentToReplace?.templateIds.length ? documentToReplace.templateIds : undefined;
}
